import { formatAmount } from '@web/components/utils/format'
import { useState } from 'react'

export const isCurrencyRegexString = '^$?d{1,3}(,d{3})*(.d{2})?$'

export const useNumberMask = (
  state: [number | null, React.Dispatch<React.SetStateAction<number | null>>],
): [string, number | null, (stringValue: string) => void] => {
  const [value, setValue] = state
  const [numberMask, setNumberMask] = useState<string>(value === null ? '' : formatAmount(value))

  const onChange = (stringValue: string) => {
    // remove non-numeric characters
    const value = stringValue.replace(/[^0-9.]/g, '')

    // handle entering decimal point
    if (stringValue.endsWith('.')) {
      setNumberMask(stringValue)
      return
    }
    // has more than two decimal places
    if (!/^\d*(\.\d{0,2})?$/.test(value)) {
      return
    }

    // handle trailing zeroes
    if (value.match(/\.\d*0+$/)) {
      setNumberMask(stringValue)
      const number = Number(value)
      if (!isNaN(number)) setValue(number)
      return
    }

    const number = Number(value)
    setNumberMask(isNaN(number) || stringValue === '' ? '' : formatAmount(number))

    setValue(isNaN(number) ? null : number)
  }

  return [numberMask || '', value, onChange]
}
